import { IconDefinition } from "./types";

const pen: IconDefinition = {
  iconName: "pen",
  width: 576,
  height: 512,
  svgPathData:
    "M16 528c5.8-20.7 24.5-87.4 56-200L382.1 17.9 416-16C431.6-.4 468.3 36.3 526.1 94.1L560 128 526.1 161.9 216 472C103.4 503.5 36.8 522.2 16 528zm174.9-98.8L397.1 223 321 146.9 114.8 353 85.2 458.8 190.9 429.2zM431 189.1L492.1 128 416 51.9 354.9 113 431 189.1z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "pen",
  unicode: 0xf304,
};

export { pen };
